import {
  registerInterest
} from "./chunk-CDFP2POK.mjs";

// src/hooks/wbk/interest/register.ts
import { useMutation } from "@tanstack/react-query";
var useRegisterInterest = () => {
  return useMutation({
    mutationFn: registerInterest
  });
};

export {
  useRegisterInterest
};
//# sourceMappingURL=chunk-45MTMAMD.mjs.map